import Vue from 'vue';
import Component from 'vue-class-component';

@Component()
export default class LocationIntervalMixin extends Vue {
  secondInterval = null;
  minuteInterval = null;

  createInterval () {
    this.secondInterval = setInterval(() => this.secondHandler(), 1000);
    this.minuteInterval = setInterval(() => this.minuteHandler(), 180000);
  }

  secondHandler () {
    this.$store.commit('addSecondsToCurrentTime', 1);
    this.$store.dispatch('refreshLocation', this.locationId);
  }

  minuteHandler () {
    this.$store.dispatch('getCurrentTime');
    this.$store.dispatch('refreshEntireLocationFromApi', this.locationId);
  }

  beforeDestroy () {
    clearInterval(this.secondInterval);
    clearInterval(this.minuteInterval);
  }
}
